export default __webpack_public_path__ + "static/media/2.88852de8.jpg";